import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { Text } from '@atlaskit/primitives';
import type { UpdateType } from '@app/app-updates/src/schema';
import { getChangeTypeMessage, type ChangeTypeId } from '@app/app';

export interface UpdateChangeTypeProps {
  type?: UpdateType['type'];
}

export const UpdateChangeType: React.FC<UpdateChangeTypeProps> = ({ type }) => {
  if (!type) {
    return null;
  }

  // Check if the type is a known ChangeTypeId
  const knownChangeTypes: ChangeTypeId[] = [
    'IMPROVEMENT',
    'FIX',
    'EXPERIMENT',
    'REMOVED',
    'ANNOUNCEMENT',
  ];

  if (knownChangeTypes.includes(type as ChangeTypeId)) {
    const changeTypeId = type as ChangeTypeId;
    const messageDescriptor = getChangeTypeMessage(changeTypeId);

    return (
      <Text>
        <FormattedMessage {...messageDescriptor} key={messageDescriptor.id} />
      </Text>
    );
  }

  // Fallback for unknown change types
  return <Text>{type}</Text>;
};
